import { Pipe, PipeTransform } from '@angular/core';
import { PostingTypeEnum } from 'app/library/posting/models/posting-type.enum';

@Pipe({
    name: 'getOpenListingButtonLabel',
})
export class GetOpenListingButtonLabelPipe implements PipeTransform {
    transform(contentTypeName: string | null | undefined): string {
        switch (contentTypeName) {
            case PostingTypeEnum.Program:
                return 'LISTINGS.BUTTON.OPEN_PROGRAM';
            case PostingTypeEnum.E_learning:
                return 'LISTINGS.BUTTON.OPEN_E_LEARNING';
            default:
                return 'LISTINGS.BUTTON.OPEN_COURSE';
        }
    }
}
